'use client'
import Image from 'next/image'
import type {
  AnnualReportIconContent,
  AnnualReportIconWithTitle,
} from '@/.generated/sanityTypes/graphql'
import { useLocale } from 'next-intl'
import type { Locale } from '@/i18n'
import { withNewLines } from '@/lib/newline'

const IconContentBlock = ({
  title,
  subtitle,
  content,
  icons,
}: AnnualReportIconContent) => {
  const locale = useLocale() as Locale

  return (
    <div className="w-full bg-white">
      <div className="text-gray-dark relative m-auto flex max-w-screen-lg flex-col gap-10 px-6 pb-10 pt-8 text-center lg:px-0">
        <div className="mb-2">
          <h2 className="text-lg/[23px] font-medium md:text-3xl/10">
            {withNewLines(title?.[locale])}
          </h2>
          {subtitle && (
            <h3 className="text-lg/[23px] font-light md:text-3xl/10">
              {withNewLines(subtitle[locale])}
            </h3>
          )}
        </div>
        <div className="flex flex-col gap-10 px-10 md:flex-row md:items-start md:gap-16">
          {icons &&
            icons.map((icon) => {
              return <IconWithText key={icon?._key} {...icon} />
            })}
        </div>
        <p className="text-lg/[23px] font-light md:text-3xl/10">
          {content?.[locale]}
        </p>
      </div>
    </div>
  )
}

const IconWithText = ({
  title,
  subtitle,
  image,
}: AnnualReportIconWithTitle) => {
  const locale = useLocale() as Locale

  return (
    <div className="flex flex-1 flex-col">
      <div className="relative m-auto mb-4 h-20 w-20 md:mb-9">
        <Image
          src={image?.asset?.url!}
          alt={image?.asset?.altText || ''}
          fill
          blurDataURL={image?.asset?.metadata?.lqip || undefined}
          placeholder="blur"
        />
      </div>
      <h4 className="mb-1 text-[15px]/[19px] font-medium uppercase md:text-xl/[26px]">
        {title?.[locale]}
      </h4>
      <p className="text-[15px]/[19px] font-light md:text-xl/[26px]">
        {subtitle?.[locale]}
      </p>
    </div>
  )
}

export default IconContentBlock
